import React from "react";
import styled from "styled-components";
import close from "../Assets/Close.png";
import { BREAKPOINTS } from "../config/breakpoints";
import { zIndex } from "../config/zIndex";

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: ${zIndex.modalBackdrop};
`;

const Panel = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: ${(props) => props.$width};
	border-radius: 10px;
	overflow-x: hidden;
	z-index: ${zIndex.modal};
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		width: 95%;
	}
`;

const Header = styled.div`
	color: #fff;
	background: rgba(45, 35, 66, 0.8);
	padding: 1rem 1.5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const Title = styled.h2`
	font-size: 1.25rem;
	font-weight: 600;
	margin: 0;
`;

const CloseButton = styled.button`
	color: #6b7280;
	transition: color 0.2s ease;
	background: transparent;
	outline: none;
	border: none;
	cursor: pointer;
	padding: 0;
	&:hover {
		color: #374151;
	}
`;

const Body = styled.div`
	padding: 1.5rem;
	overflow-y: auto;
	max-height: 70vh;
	background: #f2f2f2;
`;

/**
 * Shared modal shell (ConfirmModal overlay + panel).
 * Optional `title` renders the purple header + close; omit for children-only chrome.
 */
const Modal = ({ isOpen, onClose, title, width = "60%", children }) => {
	if (!isOpen) return null;

	return (
		<Overlay onClick={onClose}>
			<Panel $width={width} onClick={(event) => event.stopPropagation()}>
				<Header>
					<Title>{title}</Title>
					<CloseButton type="button" onClick={onClose} aria-label="Close modal">
						<img
							src={close}
							alt="close"
							style={{
								height: "30px",
								filter:
									"invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
							}}
						/>
					</CloseButton>
				</Header>
				<Body className="no-scrollbar">
					{children}
				</Body>
			</Panel>
		</Overlay>
	);
};

export default Modal;
